import styled from "styled-components";
import grain from "./../../assets/images/grainBackground.svg";
import { images } from "../../imageValues";

export const Container = styled.div`
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: #f8c933;
  background-image: url(${images.BACKGROUND});
  background-blend-mode: multiply;
  overflow: hidden;
  /* animation: marquee 100s linear infinite;

  @keyframes marquee {
    0% {
      background-position: 0 0;
    }
    100% {
      background-position: 100% 0;
    }
  } */
`;

export const PlayGround = styled.div`
  height: 50%;
  aspect-ratio: (1 / 2);
  display: flex;
  justify-content: center;
  flex-direction: column;
  max-width: 380px;
  display: flex;
  flex: 1;
`;

export const MatchBoxStrip = styled.img`
  height: 20px;
  width: 100%;
`;

export const CenterArea = styled.div`
  height: 600px;
  background-color: #463048;
  width: 380px;
  display: flex;
  color: #171312;
  background-image: url(${grain});
  background-blend-mode: multiply;
  background-size: cover;
  background-repeat: no-repeat;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

export const DiceButton = styled.button`
  margin-left: 20px;
  margin-right: 20px;
  background: none;
  background-color: orange;
  background-image: url(${grain});
  background-blend-mode: multiply;
  border: none;
  :active {
    transform: translateY(1px);
  }
`;

export const KaudiImage = styled.img`
  height: 100px;
  width: 100px;
`;

export const RoomImage = styled.img`
  width: 320px;
`;

export const TutorialContentArea = styled.div`
  background-color: #463048;
  background-image: url(${grain});
  background-blend-mode: multiply;
  color: white;
  text-align: center;
  font-weight: 600;
  padding: 15px 75px 15px 75px;
`;

export const MatchBoxStripArea = styled.span`
  display: flex;
  flex-direction: row;
  position: relative;
  width: 100%;
`;

export const MatchBoxStripButton = styled.button`
  position: absolute;
  right: 0;
  height: 100%;
  background-color: transparent;
  background: none;
  border: none;
  top: 1.75px;
  cursor: pointer;
  width: 30px;
  height: 38px;
`;

export const AppButton = styled.button`
  background-color: transparent;
  background: none;
  border: none;
  cursor: pointer;
  width: 30px;
  height: 38px;
  :active {
    transform: translateY(1px);
  }
`;
export const ButtonArea = styled.div`
  position: absolute;
  z-index: 1px;
  left: 4px;
  top: 10px;
  display: flex;
  flex-direction: row;
  gap: 30px;
`;

export const ModalButton = styled.button`
  /* background-color: ; */
  cursor: pointer;
  :active {
    transform: translateY(1px);
  }
  font-size: 14px;
`;
export const OuterDiv = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  width: 380px;
  margin-top: 10px;
  margin-bottom: 10px;
`;
export const DivButtons = styled.button`
  width: 30px;
  height: 30px;
  border: none;
  border-radius: 30px;
  justify-content: center;
  align-items: center;
  display: flex;
  cursor: pointer;
`;
export const ButtonImg = styled.img`
  width: 30px;
  height: 30px;
`;
